// extracted by mini-css-extract-plugin
export var closeButton = "_2f-3";
export var header = "_2f-0";
export var link = "_2f-1";
export var retryButton = "_2f-2";